import { useState, useRef } from 'react';
import { X, Tag } from 'lucide-react';
import './ui-components.css';

export default function TagSelector({ tags = [], onChange, placeholder = "Add tag..." }) {
    const [input, setInput] = useState('');
    const inputRef = useRef(null);
    const [focused, setFocused] = useState(false);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const val = input.trim();
            if (val && !tags.includes(val)) {
                onChange([...tags, val]);
                setInput('');
            }
        } else if (e.key === 'Backspace' && !input && tags.length > 0) {
            e.preventDefault();
            onChange(tags.slice(0, -1));
        }
    };

    const removeTag = (tagToRemove) => {
        onChange(tags.filter(t => t !== tagToRemove));
        inputRef.current?.focus();
    };

    return (
        <div 
            className={`tag-selector ${focused ? 'tag-selector--focused' : ''}`}
            onClick={() => inputRef.current?.focus()}
        >
            {tags.length === 0 && !input && !focused && (
                <div className="tag-selector__icon">
                    <Tag size={14} />
                </div>
            )}
            
            {tags.map(tag => (
                <span key={tag} className="tag-selector__pill">
                    {tag}
                    <button 
                        type="button" 
                        className="btn btn-ghost btn-sm btn-icon tag-selector__remove"
                        onClick={(e) => { e.stopPropagation(); removeTag(tag); }}
                    >
                        <X size={10} />
                    </button>
                </span>
            ))}
            
            <input
                ref={inputRef}
                className="tag-selector__input"
                type="text"
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                placeholder={tags.length === 0 ? placeholder : ''}
                style={{ width: input ? `${Math.max(input.length + 2, 5)}ch` : (tags.length === 0 ? '100%' : '10px') }}
            />
        </div>
    );
}
